/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ReactionType = {
    like: 'like',
    dislike: 'dislike',
    fire: 'fire',
    love: 'love',
    lol: 'lol',
    sad: 'sad'
} as const;
export type ReactionType = typeof ReactionType[keyof typeof ReactionType];

